import subprogramNbaSumaryStore from '@modules/subprogram/nba/subprogram-nba-summary-store'
import subprogramNbaScheduleStore from '@modules/subprogram/nba/subprogram-nba-schedule-store'
import subprogramNbaStandingsStore from '@modules/subprogram/nba/subprogram-nba-standings-page-store'
import subprogramNbaSchoolFormStore from '@modules/subprogram/nba/subprogram-nba-school-form-store'
import subprogramNbaSchoolTeamCardStore from '@modules/subprogram/nba/subprogram-nba-school-team-card-store'
import subprogramNbaRoundsStore from '@modules/subprogram/nba/subprogram-nba-rounds-store'

import { SubprogramService } from '@modules/subprogram/subprogram-service'
import { ProgramService } from '@modules/program/program-service'
import { GameService } from '@modules/game/game-service'
import Errors from '@shared/error/errors'
import { i18n } from '@shared/i18n'
import { get, update } from 'lodash'

const tabsConfig = {
  summary: {
    disabled: false,
    type: 'summary',
    label: i18n('entities.subprogram.nba.tabs.summary'),
    createButtonLink: 'TODO: Create Button Link',
    createButtonCode: i18n('programs.league.new'),
    editButtonLink: 'TODO: Edit Button Link',
    editButtonCode: i18n('programs.league.edit'),
    routerPush: {
      params: {
        tabName: 'summary',
      },
    },
  },
  schedule: {
    disabled: false,
    type: 'schedule',
    label: i18n('entities.subprogram.nba.tabs.schedule'),
    routerPush: {
      params: {
        tabName: 'schedule',
      },
    },
  },
  standings: {
    disabled: false,
    type: 'standings',
    label: i18n('entities.subprogram.nba.tabs.standings'),
    routerPush: {
      params: {
        tabName: 'standings',
      },
    },
  },
  participants: {
    disabled: true,
    type: 'participants',
    label: i18n('entities.subprogram.nba.tabs.participants'),
    routerPush: {
      params: {
        tabName: 'participants',
      },
    },
  },
  rounds: {
    disabled: false,
    type: 'rounds',
    label: i18n('entities.subprogram.nba.tabs.rounds'),
    createButtonLink: 'TODO: Create Button Link',
    createButtonCode: i18n('entities.subprogram.nba.rounds.add'),
    editButtonLink: 'TODO: Edit Button Link',
    editButtonCode: i18n('entities.subprogram.nba.rounds.edit'),
    routerPush: {
      params: {
        tabName: 'rounds',
      },
    },
  },
}

export default {
  namespaced: true,

  modules: {
    summary: subprogramNbaSumaryStore,
    schedule: subprogramNbaScheduleStore,
    standings: subprogramNbaStandingsStore,
    schoolForm: subprogramNbaSchoolFormStore,
    teamCard: subprogramNbaSchoolTeamCardStore,
    rounds: subprogramNbaRoundsStore,
  },

  state: {
    tabIndex: 0,
    tabs: [],
    subpropertyId: null,
    programId: null,
    subprogramId: null,
    subprogram: null,
    program: null,
    loading: false,
  },

  getters: {
    tabs: state => state.tabs.filter(tab => tab.disabled === false),
    tabIndex: state => state.tabIndex,
    subpropertyId: state => state.subpropertyId,
    programId: state => state.programId,
    subprogramId: state => state.subprogramId,
    subprogram: state => state.subprogram,
    program: state => state.program,
    loading: state => state.loading,
  },

  mutations: {
    SET_TABS(state, payload) {
      state.tabs = payload
    },
    SET_TAB_INDEX(state, payload) {
      state.tabIndex = payload
    },
    INIT_PARAMS(state, {
      subpropertyId,
      programId,
      subprogramId,
    }) {
      state.subpropertyId = subpropertyId
      state.programId = programId
      state.subprogramId = subprogramId
    },
    LOAD_STARTED(state) {
      state.loading = true
      state.program = null
      state.subprogram = null
    },
    LOAD_SUCCESS(
      state,
      {
        program,
        subprogram,
      },
    ) {
      state.loading = false
      state.program = program
      state.subprogram = subprogram
    },
    LOAD_ERROR(state) {
      state.loading = false
      state.program = null
      state.subprogram = null
    },
  },

  actions: {
    doResetTabs({ commit }) {
      commit('SET_TAB_INDEX', 0)
    },
    setTabIndex({ commit }, tabIndex) {
      commit('SET_TAB_INDEX', tabIndex)
    },
    async doInitParams(
      { commit },
      { subpropertyId, programId, subprogramId },
    ) {
      const manageInput = {
        type: 'subproperty',
        subpropertyId,
        programId,
      }
      commit('INIT_PARAMS', {
        subpropertyId,
        programId,
        subprogramId,
      })

      try {
        commit('LOAD_STARTED')

        const p1 = new Promise(resolver => resolver(ProgramService.find(
          programId,
          manageInput,
        )))

        const p2 = new Promise(resolver => resolver(SubprogramService.find(
          subprogramId,
          manageInput,
        )))

        Promise.all([p1, p2]).then(values => {
          const program = values[0]
          const subprogram = values[1]

          const isStartRegularSeason = get(subprogram, 'regularSeasonConfigured', false)
          const isRegularSeasonHasRounds = get(subprogram, 'regularSeasonHasRounds', false)
          const playoffsStarted = get(subprogram, 'playoffsStarted', false)

          // Setting tabs
          update(tabsConfig, 'schedule.disabled', () => !isStartRegularSeason)
          update(tabsConfig, 'standings.disabled', () => !isStartRegularSeason)
          update(tabsConfig, 'rounds.disabled', () => !isRegularSeasonHasRounds || playoffsStarted)
          // update(tabsConfig, 'participants.disabled', () => !isStartRegularSeason )
          const tabs = Object.values(tabsConfig)

          commit('SET_TABS', tabs)
          commit('LOAD_SUCCESS', { program, subprogram })
        })
      } catch (error) {
        Errors.handle(error)
        commit('LOAD_ERROR')
      }
    },

    async getGamesStats(context, { subpropertyId, subprogramId }) {
      const filter = {
        subprogram: subprogramId,
      }
      const orderBy = null
      const limit = 0
      const offset = 0
      const { rows, count } = await GameService.competitionGameList(subpropertyId, filter, orderBy, limit, offset)
      const playedCount = rows.filter(game => game.status === 'played').length
      const unplayedCount = rows.filter(game => game.status === '').length

      return { totalCount: count, playedCount, unplayedCount }
    },
  },
}
